import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CmsApiService } from './api/cms-api.service';
import { CmsContentMapperService } from './cms-content-mapper.service';
import { ContentUpdaterService } from './content-updater/content-updater.service';

@Injectable({
  providedIn: 'root',
})
export class OffersService {
  private _api = inject(CmsApiService);
  private _mapper = inject(CmsContentMapperService);
  private _contentUpdate = inject(ContentUpdaterService);


  /**
   * Get promotions list from CMS and prepare for using in frontend
   * @param params
   */
  list(params: object = {}): Observable<any> {
    return this._contentUpdate.registerContent('promo/list', params, () =>
      this._api.promotionList(params).pipe(
        map(response => this._mapper.mapCmsData(response.data, {
          slug: 'slug',
          id: 'id',
          cmsItemName: 'name',
          publishAt: 'publishAt.date',
        })),
      ));
  }

  /**
   * Get promotions item from CMS and prepare for using in frontend
   * @param params
   */
  item(params: object = {}): Observable<any> {
    return this._contentUpdate.registerContent('promo/item', params, () =>
      this._api.promotionItem(params).pipe(
        map(response => {
          if (response.statusCode === 200) {
            return this._mapper.mapCmsData(response.data, {
              slug: 'slug',
              publishAt: 'publishAt.date',
              unpublishAt: 'unpublishAt.date',
              name: 'name',
            });
          } else {
            return [{
              statusCode: response.statusCode,
            }];
          }
        }),
      ));
  }
}
